import React from 'react';
import {AvGroup} from "availity-reactstrap-validation";
import {Col, Label, Row} from "reactstrap";
import AvField from "../../shared/component/form/AvField";

const defaultRoom = {
    id: '',
    name:''
    
};
export default class RoomSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            room: defaultRoom,
            pageMode: null
        };
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col>
                    <AvGroup>
                        <Label for="name">Ad<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="name"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 50,
                                    errorMessage: 'Bu alan en fazla 50 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.room.name}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>
                </Col>
            </Row>
        );
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let room = this.state.room;
        room[e.target.name] = value;
        this.setState({room: room});
    }

    setData = (data, pageMode) => {
        this.setState({room: data, pageMode: pageMode});
    }

    getData = () => {
        return this.state.room;
    }

    clearData = () => {
        this.setState({room: Object.assign({}, defaultRoom), pageMode: null});
    }

}
